// Which built-in shortcuts exist for this student, and which of them are on the start page.
// Pure (takes the settings getter), so the start page, All shortcuts and the tests agree.

// Desktop is left out inside Re:Vault OS (it is already the desktop). A preview shortcut shows
// once it has been switched on (`seen` holds those ids), so taking it off the start page later
// still leaves it here.
export function builtInShortcuts(list, get, { inOS = false, seen = [] } = {}) {
	return list.filter((sc) => !(sc.env && inOS) && (!sc.preview || get(sc.flag) === true || seen.includes(sc.id)));
}

// The preview shortcuts that are on right now, added to the ones seen before.
export function seenPreviews(list, get, seen = []) {
	const out = new Set(seen);
	for (const sc of list) if (sc.preview && get(sc.flag) === true) out.add(sc.id);
	return [...out];
}

// A shortcut is on unless its flag is false, so saves from before a shortcut existed keep it.
export const shortcutOn = (sc, get) => get(sc.flag) !== false;

// The tiles on the start page, in order. All shortcuts is always added after these.
export function startTiles(list, get, opts) {
	if (get("showShortcuts") === false) return [];
	return builtInShortcuts(list, get, opts).filter((sc) => shortcutOn(sc, get));
}

// The settings patch that brings one (or several) back, turning the row on if it was off.
// A pinned tool's tile carries its tool id in `val`.
export function addBackPatch(scs, get) {
	const patch = {};
	for (const sc of scs) patch[sc.flag] = sc.val || true;
	if (get("showShortcuts") === false) patch.showShortcuts = true;
	return patch;
}

// One study tool pinned to the start page (setting pinTool). Its tile leads the row and opens like
// a Tools card; taking it off clears the setting. `tools` is the tools manifest.
export function pinnedTile(tools, get) {
	const id = get("pinTool");
	const t = get("showShortcuts") !== false && typeof id === "string" && id ? tools.find((x) => x.id === id) : null;
	return t ? { id: "pin", label: t.name, page: "/tools/" + t.id, flag: "pinTool", val: t.id, icon: t.icon } : null;
}
// Pin a tool (it replaces the one pinned before), or unpin it when it is already the pinned one.
export function pinToolPatch(id, get) {
	if (get("pinTool") === id) return { pinTool: "" };
	return Object.assign({ pinTool: id }, get("showShortcuts") === false ? { showShortcuts: true } : {});
}
